<template>
    <div>
                        <div class="cstm-unique-tab-text">
                            <div class="px-2">
                                <div class="flex flex-wrap -mx-2">
                                    <div class="w-full px-2 my-2">
                                        <vs-input class="w-full" v-model="projectData.name" placeholder="Project Name" />
                                    </div>
                                    <div class="w-full px-2 my-2">
                                        <vs-textarea class="mb-0" v-model="projectData.details" label="Description"  />
                                    </div>
                                    <div class="md:w-1/2 w-full px-2 my-2">                                
                                        <span>Due Date</span>
                                        <flat-pickr  class="cstm-datepicker w-full" v-model="projectData.due_date"  placeholder="Select Date" :config="configdateTimePicker1"/>
                                                                     
                                    </div>
                                    <div class="md:w-1/2 w-full px-2 my-2">
                                        <div class="person-holder">
                                            <div>
                                                <feather-icon icon="UserIcon" />
                                                <span>Members</span>
                                            </div>
                                            <div class="cstm-inp flex-wrap">
                                                <span class="cstm-badge flex items-center" :key="index" v-for="(person, index) in memberData">
                                                    {{person.first_name}} {{person.last_name}}
                                                    <feather-icon class="cursor-pointer" icon="XIcon"  @click="closeSelectedProject('Member',index)"/>
                                                </span>
                                                <a class="font-bold cursor-pointer" @click="addMoreUser('Member')">+ Add More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-full px-2 my-2">
                                        <div class="person-holder">
                                            <div>
                                                <feather-icon icon="UserIcon" />
                                                <span>Status Listing (Re-Order the status by dragging)</span>
                                            </div>
                                            <div class="cstm-inp flex-wrap">
                                                <draggable :list="allTaskStatus" @change="statusLog" class="w-full p-2 cursor-move">
                                                    <span v-for="(taskStatus, index) in allTaskStatus" :key="index" class="cstm-badge w-full flex items-center justify-between mx-0 my-2">
                                                        <p>{{taskStatus.name}}</p>
                                                        <feather-icon @click="closeStatus(index)" class="cursor-pointer" icon="XIcon" />
                                                    </span>
                                                </draggable>
                                                <a class="font-bold cursor-pointer" @click="statusActive=true">+ Add More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Task creation with project form -->
                        <div class="relative">
                          <vs-card
                            v-for="(task_detail, index) in all_task_details"
                            :key="index"
                          >
                            <div slot="header" class="flex justify-between">
                              <h4>Task {{index + 1}}</h4>
                              <vs-button icon-pack="feather" color="danger" @click="removeCard(index)" type="flat" icon="icon-trash-2"></vs-button>
                            </div>
                            <div class="cstm-unique-tab-text">
                                <div class="px-2">
                                    <div class="flex flex-wrap -mx-2">
                                        <div class="w-full px-2 my-2">
                                            <vs-input class="w-full" placeholder="Task Name" v-model="task_detail.name"/>
                                        </div>
                                        <div class="md:w-1/2 w-full px-2 my-2">
                                        <v-select
                                        v-model="task_detail.projectStatusTag"
                                        v-validate="'required'"
                                        :reduce="option => option.name"
                                        label="name"
                                        name="name"
                                        :options="allTaskStatus"
                                        placeholder="Choose Status"
                                        style="width:100%;"
                                    />
                                        </div>
                                        <div class="md:w-1/2 w-full px-2 my-2">
                                        <v-select
                                        v-model="task_detail.task_priority_id"
                                        v-validate="'required'"
                                        :reduce="option => option.id"
                                        label="level"
                                        name="level"
                                        :options="priority"
                                        placeholder="Choose Priority"
                                        style="width:100%;"
                                    />
                                        </div>
                                        <div class="w-full px-2 my-2">
                                            <vs-textarea class="mb-0" label="Details" v-model="task_detail.details" />
                                        </div>
                                        <div class="md:w-1/2 w-full px-2 my-2">
                                            <div class="person-holder">
                                                <div>
                                                    <feather-icon icon="UserIcon" />
                                                    <span>Responsible Person</span>
                                                </div>
                                                <div class="cstm-inp flex-wrap">
                                                <span class="cstm-badge flex items-center" :key="index" v-for="(person, index) in task_detail.ResponsiblePersonData">
                                                    {{person.first_name}} {{person.last_name}}
                                                    <feather-icon class="cursor-pointer" icon="XIcon"  @click="closeSelectedProject('ResponsiblePerson',index)"/>
                                                </span>
                                                <a class="font-bold cursor-pointer" @click="addMoreUserProject('ResponsiblePerson', index)">+ Add More</a>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="md:w-1/2 w-full px-2 my-2">                                
                                            <span>Deadline</span>
                                            <flat-pickr  class="cstm-datepicker w-full" v-model="task_detail.due_date" placeholder="Select Date" @input="ProjectUpdateCalendar(index)" :config="configdateTimePicker1"/>                            
                                        </div>
                                        <vs-divider />

                                        <vs-tabs class="inner-tab" v-model="selectedTab">
                                            <vs-tab label="" icon-pack="feather" icon="icon-users">
                                                <div class="my-2">
                                                    <div class="flex items-center">
                                                        <feather-icon icon="UserIcon" />
                                                        <span class="mx-1">Created By</span>
                                                    </div>
                                                    <div class="flex flex-wrap -mx-2">
                                                        <div class="w-full px-2">
                                                            <vs-input class="w-full" :value="userInfo.first_name" readonly />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="my-2">
                                                    <div class="flex items-center">
                                                        <feather-icon icon="UserIcon" />
                                                        <span class="mx-1">Participants</span>
                                                    </div>
                                                    <div class="flex flex-wrap -mx-2">
                                                       <div class="cstm-inp flex-wrap">
                                                        <span class="cstm-badge flex items-center" :key="index" v-for="(person, index) in task_detail.ParticipantPersonData">
                                                            {{person.first_name}} {{person.last_name}}
                                                            <feather-icon class="cursor-pointer" icon="XIcon"  @click="closeSelectedProject('ParticipantPerson',index)"/>
                                                        </span>
                                                        <a class="font-bold cursor-pointer" @click="addMoreUserProject('ParticipantPerson', index)">+ Add More</a>
                                                    </div>
                                                    </div>
                                                </div>

                                                <div class="my-2">
                                                    <div class="flex items-center">
                                                        <feather-icon icon="UserIcon" />
                                                        <span class="mx-1">Observers</span>
                                                    </div>
                                                    <div class="flex flex-wrap -mx-2">
                                                        <div class="cstm-inp flex-wrap">
                                                <span class="cstm-badge flex items-center" :key="index" v-for="(person, index) in task_detail.observerPersonData">
                                                    {{person.first_name}} {{person.last_name}}
                                                    <feather-icon class="cursor-pointer" icon="XIcon"  @click="closeSelectedProject('observerPerson',index)"/>
                                                </span>
                                                <a class="font-bold cursor-pointer" @click="addMoreUserProject('observerPerson', index)">+ Add More</a>
                                            </div>
                                                    </div>
                                                </div>
                                            </vs-tab>

                                            <vs-tab label="" icon-pack="feather" icon="icon-clock">
                                            <div>
                                                <div class="flex items-center my-2">
                                                    <feather-icon icon="ClockIcon" />
                                                    <span class="mx-1">Time Planning</span>
                                                </div>
                                                <flat-pickr :config="task_detail.configdateTimePicker" v-model="task_detail.from_time" placeholder="From" /> &nbsp;
                                                <flat-pickr :config="task_detail.configdateTimePicker" v-model="task_detail.to_time" placeholder="To" />
                                                <vs-divider />
                                                <div class="flex items-center my-2">
                                                    <feather-icon icon="ClockIcon" />
                                                    <vs-checkbox v-model="task_detail.is_tracking_active" >Time Tracking</vs-checkbox>
                                                </div>
                                            </div>
                                        </vs-tab>

                                            <vs-tab label="" icon-pack="feather" icon="icon-list">
                                             <span v-if="task_detail.checklist.length !== 0">
                                              <span :key="index8" v-for="(item1, index8) in task_detail.checklist">
                                                <div class="flex flex-wrap items-center">
                                                <div class="flex items-center my-2 lg:w-1/5 w-full">
                                                       <span class="material-icons">assignment</span>
                                                       <span class="mx-2">{{item1.name}}</span>
                                                </div>
                                                   <vs-progress class="lg:w-1/2 md:w-3/5" :percent="(item1.itemStatusCal.length/item1.todos.length)*100" color="primary"></vs-progress>
                                                    <div class="progress-status">
                                                        Completed: {{item1.itemStatusCal.length}} out of {{item1.todos.length}}
                                                    </div>
                                                </div>
                                                     <ul class="checklist-ul task-checklist mb-4" >
                                                    <li class="flex justify-between"  :key="index9" v-for="(item2, index9) in item1.todos">{{item2.todo}} 
                                                      <vs-checkbox v-model="item2.is_completed" @change="changeStatusProject(index, index8, index9)" ></vs-checkbox>
                                                      <vs-button color="danger" @click="deleteItemProject(index, index8, index9)" icon-pack="feather" icon="icon-trash-2" type="flat" ></vs-button>
                                                    </li> 
                                                     </ul>
                                              </span>  
                                           
                                          </span> 
                                         
                                            <div :key="index3" v-for="(checklistRow, index3) in task_detail.checklistRows" >

                                                <div class="flex flex-wrap items-center">
                                                    <div class="flex items-center my-2 lg:w-1/5 w-full">
                                                        <span class="material-icons">assignment</span>
                                                        <span class="mx-2">Checklist {{index3 + 1}}</span>
                                                    </div>
                                                    
                                                    <vs-progress class="lg:w-1/2 md:w-3/5" :percent="(checklistRow.itemStatusCal.length/checklistRow.items.length)*100" color="primary"></vs-progress>
                                                    <div class="progress-status">
                                                        Completed: {{checklistRow.itemStatusCal.length}} out of {{checklistRow.items.length}}
                                                    </div>
                                                  
                                                </div>
                                                <ul class="checklist-ul task-checklist mb-4">

                                                    <li  class="flex justify-between"  :key="index6" v-for="(item, index6) in checklistRow.items">{{item.todo}} 
                                         
                                                      <vs-checkbox v-model="item.is_completed" @change="changeStatusProjectFromCheck(index, index3, index6)" ></vs-checkbox>
                                                      <vs-button color="danger" @click="deleteItemProjectFromCheck(index, index3, index6)" icon-pack="feather" icon="icon-trash-2" type="flat" ></vs-button>
                                                      </li> 
                                                   
                                                </ul>
                                                <div class="flex justify-between" :key="index2" v-for="(testBox, index2) in checklistRow.showTextBox">
                                                <vs-input class="inputx mb-4" placeholder="Item Name"  v-model="testBox.itemName" />
                                                <vs-button color="danger" icon-pack="feather"
                icon="icon-trash-2" type="flat" @click="removeItem(checklistRow, index2)" ></vs-button></div>
                                                
                                                
                                                <vs-button  @click="addItem(checklistRow)">+ Item</vs-button>
                                                <vs-button class="ml-1" color="success" v-if="checklistRow.showTextBox.length >0" @click="submitItemProject(index, index3,checklistRow)">Save</vs-button>
                                                <vs-button class="float-right" color="danger" @click="removeChecklistProject(index, index3)" type="flat">Remove</vs-button>
                                                <vs-divider />

                                                
                                            </div>
                                          
                                            <vs-button class="my-4" @click="addChecklistProject(index)">+ Checklist</vs-button>
                                        </vs-tab>

                                           <vs-tab label="" icon-pack="feather" icon="icon-grid">
                                        <div>
                                               <div class="flex flex-wrap items-center">
                                                    <div class="w-1/5">
                                                        <label>Remind about task</label>
                                                    </div>
                                                     <div class="reminder_holder">
                                                        <div class="inline-flex items-center m-1" :key="index12" v-for="(item, index12) in task_detail.reminderTime">
                                                            <!-- {{item.reminder_time}} -->
                                                            <flat-pickr :config="configdateTimePicker1" v-model="item.reminder_time" placeholder="Choose Date & Time" /> 
                                                            <vs-button class="cursor-pointer font-semibold ml-1" @click="removeReminderProj(index, index12)" icon-pack="feather" icon="icon-minus"  color="danger"></vs-button>
                                                        </div>
                                                        <a class="cursor-pointer font-semibold block" @click="addReminderProj(index)">+ Reminder</a>
                                                    </div>
                                                </div>
                                            <vs-divider />
                                            <div class="flex flex-wrap items-center">
                                                <label class="w-1/5">Gantt</label>
                                                <a class="cursor-pointer font-semibold">+ Add Previous Task</a>
                                            </div>
                                            <vs-divider />

                                            <div class="flex flex-wrap items-center">
                                                <label class="w-1/5">CRM</label>
                                                <div class="cstm-inp w-1/2">
                                                 <span class="cstm-badge flex items-center" :key="index8" v-for="(crm, index8) in task_detail.selectedCRMData">
                                                        {{crm.lead_name}}
                                                        <feather-icon class="cursor-pointer" icon="XIcon" @click="closeSelectedProject('CRM',index8)"/>
                                                    </span>
                                                    <a class="font-bold cursor-pointer" @click="addProjModal('CRM', index)">+ Add More</a>
                                                </div>
                                            </div>
                                            <vs-divider />

                                            <div class="flex flex-wrap items-center">
                                                <label class="w-1/5">SubTask</label>
                                                <div class="cstm-inp w-1/2">
                                                     <span class="cstm-badge flex items-center" :key="index8" v-for="(task, index8) in task_detail.selectedSubTaskData">
                                                        {{task.name}}
                                                        <feather-icon class="cursor-pointer" icon="XIcon" @click="closeSelectedProject('subTask',index8)"/>
                                                    </span>
                                                    <a class="font-bold cursor-pointer" @click="addProjModal('subTask', index)">+ Add</a>
                                                </div>
                                            </div>
                                            <vs-divider />

                                            <div class="flex flex-wrap items-center">
                                                <label class="w-1/5">Tags</label>
                                                <v-select
                                                            class="w-full"
                                                            label="name"
                                                            taggable
                                                            :reduce="(option) => option.name"
                                                            :create-option="
                                                            (option) => ({ id: option, label: option, name: option })
                                                            "
                                                            :options="tagsList"
                                                            v-model="task_detail.tags"
                                                            :clearable="false"
                                                            data-vv-name="name"
                                                            name="name"
                                                            multiple
                                                        >
                                                        </v-select>
                                            </div>
                                            <vs-divider />
                                        </div>
                                    </vs-tab>

                                            <vs-tab label="" icon-pack="feather" icon="icon-type">
                                                <editor
                                                v-model="task_detail.comments"
                                                :api-key="tinyMceApi"
                                                :init="{
                                                    height: 500,
                                                    menubar: true,
                                                    branding: false,
                                                    images_upload_url: image_url,
                                                    automatic_uploads: true,
                                                    images_upload_credentials:true,
                                                    images_upload_handler:example_image_upload_handler,
                                                    plugins: [
                                                    'autolink lists link image charmap print preview anchor',
                                                    'imagetools',
                                                    'searchreplace visualblocks code fullscreen',
                                                    'insertdatetime media table paste code help wordcount',
                                                    'code lists fullscreen',
                                                    'emoticons'
                                                    ],
                                                    menu:'table',
                                                    toolbar:'insertfile image link |undo redo | formatselect | bold italic backcolor | \
                                                    table alignleft aligncenter alignright alignjustify | \
                                                    bullist numlist outdent indent | removeformat | help',
                                                }"
                                                />
                                            </vs-tab>
                                        </vs-tabs>
                                        <vs-divider />
                                         <div v-if="task_detail.is_template === false" class="md:w-1/2 w-full px-2 my-2">                                
                                        <vs-checkbox v-model="task_detail.is_template" vs-value="1">Save this as a template</vs-checkbox>                             
                                    </div>
                                    </div>
                                </div>
                                
                            </div>
                          </vs-card>
                          <!-- right most action sidebar -->
                          <div class="fixed-actionbar">
                              <a @click.prevent="addNewTask" class="block">
                                  <vs-tooltip text="Add New Task" position="right" class="option-tooltip">
                                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.88 27.88">
                                      <circle cx="13.94" cy="13.94" r="12.94" class="cls-1"></circle>
                                      <line x1="13.94" y1="8.45" x2="13.94" y2="19.43" class="cls-1"></line>
                                      <line x1="8.45" y1="13.94" x2="19.43" y2="13.94" class="cls-1"></line>
                                  </svg>
                                  </vs-tooltip>
                              </a> 
                              <a @click="importActive=true" class="block">
                                  <vs-tooltip text="Import" position="right" class="option-tooltip">
                                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                                      <path class="st0" d="M4.78125,18.2910156v2.3330078c0,0.1975002,0.0800152,0.3906765,0.2196698,0.5303307   c0.1396542,0.1396542,0.332829,0.2196693,0.5303302,0.2196693h16.2841797c0.1975002,0,0.3906765-0.0800171,0.5303307-0.2196712   c0.1396523-0.1396542,0.2196674-0.3328285,0.2196674-0.5303288V3.3759766c0-0.1975021-0.0800152-0.3906765-0.2196674-0.5303307   c-0.1396542-0.1396542-0.3328304-0.2196693-0.5303307-0.2196693H5.53125c-0.1975012,0-0.390676,0.0800152-0.5303302,0.2196693   C4.8612652,2.9853001,4.78125,3.1784744,4.78125,3.3759766v9.9404297c0,0.4142132,0.3357863,0.75,0.75,0.75   c0.4142132,0,0.75-0.3357868,0.75-0.75L6.2812495,4.1259747h14.7841778v15.7480488H6.281249l0.0000005-1.5830078   c0-0.4142132-0.3357863-0.75-0.7499995-0.75c-0.4142137,0-0.7499995,0.3357868-0.7499995,0.75H4.78125z"/>
                                      <path class="st0" d="M8.9902344,7.3354492h9.3896484c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142151-0.3357868-0.75-0.75-0.75   H8.9902344c-0.4142141,0-0.75,0.3357849-0.75,0.75C8.2402344,6.9996624,8.5760202,7.3354492,8.9902344,7.3354492"/>
                                      <path class="st0" d="M8.9902344,10.0576172h5.5429688c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142141-0.3357868-0.75-0.75-0.75   H8.9902344c-0.4142141,0-0.75,0.3357859-0.75,0.75C8.2402344,9.7218304,8.5760202,10.0576172,8.9902344,10.0576172"/>
                                      <path class="st0" d="M2.1845703,16.8632813h9.3891602c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142141-0.3357868-0.75-0.75-0.75   H2.1845703c-0.4142137,0-0.75,0.3357859-0.75,0.75C1.4345703,16.5274944,1.7703567,16.8632813,2.1845703,16.8632813"/>
                                      <path class="st0" d="M8.3588734,13.4722681l2.4168472,2.4164467l-2.4168911,2.4168921   c-0.2928934,0.2928944-0.2928934,0.7677689,0,1.0606613s0.7677679,0.2928925,1.0606613,0l3.4776392-3.4776421L9.419446,12.41152   c-0.2929182-0.2928696-0.7677917-0.2928295-1.0606604,0.0000887c-0.2928696,0.2929173-0.2928295,0.7677908,0.0000887,1.0606604   L8.3588734,13.4722681z"/>
                                  </svg>
                                  </vs-tooltip>
                              </a>                        
                          </div>
                        </div>
                        <div class="my-2 text-right">
                            <vs-button :disabled="!buttonProjectActive" v-if="project_id" class="mx-2" @click="updateProject">Update</vs-button>
                            <vs-button :disabled="!buttonProjectActive"  v-if="!project_id" class="mx-2" @click="submitProject">Save</vs-button>
                        </div>
          <vs-popup class="holamundo userModalStyle" title="Add Responsible Person" :active.sync="popupActive">
            <vs-tabs :color="primary">
                <vs-tab label="User">
                    <div class="tab-text">
                        <div class="person-list-holder">
                            <vs-table multiple v-model="selectedUsers" :data="userList">

                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                        <vs-td :data="data[indextr].picture">
                                            <img
                                                v-if="data[indextr].picture != ''"
                                                class="person-img rounded-full shadow-md cursor-pointer block"
                                                :src="data[indextr].picture"
                                            />
                                            <img
                                                v-if="data[indextr].picture == ''"
                                                class="person-img rounded-full shadow-md cursor-pointer block"
                                                src="@/assets/images/pages/user-circle-solid.svg"
                                            />
                                        </vs-td>

                                        <vs-td :data="data[indextr].first_name">
                                            {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>

                            <vs-row vs-type="flex" vs-justify="space-between">
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w="11.5"
                            >
                            <vs-button
                                type="flat"
                                icon-pack="feather"
                                icon="icon-plus"
                                v-if="userList.length == 20 && showButtonUser == true"
                                @click="showMoreUser"
                                >Show</vs-button
                            >
                            </vs-col>
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w=".5"
                            >
                            <vs-button
                                type="flat"
                                v-if="currentPageUser > 1"
                                @click="showBackUser"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-arrow-left"
                            ></vs-button>
                            </vs-col>
                        </vs-row>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab label="Client">
                    <div class="tab-text">
                        <div class="person-list-holder">
                            <vs-table multiple v-model="selectedClients"  :data="clientList">

                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                        <vs-td :data="data[indextr].picture">

                                            <img
                                                v-if="data[indextr].picture != ''"
                                                class="person-img rounded-full shadow-md cursor-pointer block"
                                                :src="data[indextr].picture"
                                            />
                                            <img
                                                v-if="data[indextr].picture == ''"
                                                class="person-img rounded-full shadow-md cursor-pointer block"
                                                src="@/assets/images/pages/user-circle-solid.svg"
                                            />
                                            
                                        </vs-td>


                                        <vs-td :data="data[indextr].first_name">
                                            {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>
                             <vs-row vs-type="flex" vs-justify="space-between">
                                <vs-col
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                                vs-w="11.5"
                                >
                                <vs-button
                                    type="flat"
                                    icon-pack="feather"
                                    icon="icon-plus"
                                    v-if="clientList.length == 20 && showButtonClient == true"
                                    @click="showMoreClient"
                                    >Show</vs-button
                                >
                                </vs-col>
                                <vs-col
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                                vs-w=".5"
                                >
                                <vs-button
                                    type="flat"
                                    v-if="currentPageClient > 1"
                                    @click="showBackClient"
                                    color="primary"
                                    icon-pack="feather"
                                    icon="icon-arrow-left"
                                ></vs-button>
                                </vs-col>
                            </vs-row>
                        </div>
                    </div>
                </vs-tab>
               
            </vs-tabs>
            <vs-button class="float-right" @click="addUserProject">Add</vs-button>
        </vs-popup> 

          <vs-popup class="holamundo" title="Add Status Field" :active.sync="statusActive">
            <vs-input class="w-full" placeholder="Status Field" v-model="statusname" />
            <vs-button @click="addTaskStatus" class="float-right mt-4">Add</vs-button>
        </vs-popup>

        <vs-popup fullscreen class="holamundo" title="Import Task" :active.sync="importActive">
            <vs-tabs>
              <vs-tab label="Templates">
                <div>
                  <vs-table
                    multiple
                    class="import-table"
                    v-model="selected"
                    :data="ListOfTask"
                  >
                    <template slot="thead">
                      <vs-th>Task Name</vs-th>
                      <vs-th>Task Details</vs-th>
                      <vs-th>Priority</vs-th>
                      <vs-th>Created At</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].details">
                          {{ data[indextr].details }}
                        </vs-td>

                        <vs-td :data="data[indextr].task_priority.level">
                          {{ data[indextr].task_priority.level }}
                        </vs-td>

                        <vs-td :data="data[indextr].createdat">
                          {{ data[indextr].created_at }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                <vs-button v-if="meta_template.has_next" @click="loadMoreTemplate('plus')" style="float:right">Load More</vs-button>
                <vs-button v-if="meta_template.current_page>1" @click="loadMoreTemplate('minus')" style="float:right">Back</vs-button>
                </div>
              </vs-tab>
              <vs-tab label="Live Tasks">
                <div>
                  <vs-table
                    multiple
                    class="import-table"
                    v-model="selected"
                    :data="liveTaskImportData"
                  >
                    <template slot="thead">
                      <vs-th>Reference Id</vs-th>
                      <vs-th>Task Name</vs-th>
                      <vs-th>Task Details</vs-th>
                      <vs-th>Deadline</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                         <vs-td :data="data[indextr].reference_id">
                          {{ data[indextr].reference_id }}
                        </vs-td>
                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].details">
                          {{ data[indextr].details }}
                        </vs-td>

                        <vs-td :data="data[indextr].due_date">
                          {{ data[indextr].due_date }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button v-if="meta.has_next" @click="loadMoreTask('plus')" style="float:right">Load More</vs-button>
                  <vs-button v-if="meta.current_page>1" @click="loadMoreTask('minus')" style="float:right">Back</vs-button>
                </div>
              </vs-tab>
            </vs-tabs>
             <div class="my-4 text-right">
                <vs-button @click="exportToProject">Import</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo userModalStyle" title="Add CRM" :active.sync="popupActiveCRM">
           <vs-tabs :color="primary">
                <vs-tab label="CRM">
                    <div class="tab-text">
                        <div class="person-list-holder">
                            <vs-table multiple v-model="selectedCRM" :data="leadData">
                                <template slot="thead">
                                    <vs-th></vs-th>
                                    <vs-th>Select All</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td :data="data[indextr].lead_name">
                                            {{ data[indextr].lead_name }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                            <vs-row vs-type="flex" vs-justify="space-between">
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w="11.5"
                            >
                            <vs-button v-if="leadMeta.has_next" @click="showCRM('plus')" color="primary"
                                icon-pack="feather"
                                icon="icon-plus" style="float:right">More</vs-button>
                            </vs-col>
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w=".5"
                            >
                            <vs-button
                                type="flat"
                                v-if="leadMeta.current_page>1"
                                @click="showCRM('minus')"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-arrow-left"
                            ></vs-button>
                            </vs-col>
                        </vs-row>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
            <vs-button class="float-right" @click="addProjMicData('CRM')" >Add</vs-button>
        </vs-popup> 
         <vs-popup class="holamundo userModalStyle" title="Add Sub Task" :active.sync="popupActiveSubTask">
            <vs-tabs :color="primary">
                <vs-tab label="Sub Task">
                    <div class="tab-text">
                        <div class="person-list-holder">
                            <vs-table multiple v-model="selectedSubTask" :data="parentTaskData">
                                <template slot="thead">
                                    <vs-th></vs-th>
                                    <vs-th>Select All</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td :data="data[indextr].name">
                                            {{ data[indextr].name }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                            <vs-row vs-type="flex" vs-justify="space-between">
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w="11.5"
                            >
                            <vs-button v-if="sub_meta.has_next" @click="showSubTask('plus')" color="primary"
                                icon-pack="feather"
                                icon="icon-plus" style="float:right">More</vs-button>
                            </vs-col>
                            <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                            vs-w=".5"
                            >
                            <vs-button
                                type="flat"
                                v-if="sub_meta.current_page>1"
                                @click="showSubTask('minus')"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-arrow-left"
                            ></vs-button>
                            </vs-col>
                        </vs-row>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
            <vs-button class="float-right" @click="addProjMicData('subTask')" >Add</vs-button>
        </vs-popup> 
    </div>
</template>

<script>
import { TaskProject } from './mixins/task-project.js'
import Pagination from '@/components/common/pagination'
import { Project } from './mixins/project.js'
export default {
  mixins: [
    TaskProject,
    Project
  ],
  components: {
    Pagination
  },
  props: ['project_id'],
  computed: {
    buttonProjectActive () {
      if (this.all_task_details.length !== 0 && this.allTaskStatus.length !== 0 && this.projectData.name !== '' && this.memberData.length !== 0 && this.projectData.due_date !== '' && this.projectData.details !== '') {
        return true
      } else {
        return false
      }
    }

  },
  mounted () {
    this.fetchUser()
    this.fetchClient()
    this.priorityList()
    this.listOfTag(this.tag_meta.current_page)
    this.parentTask(this.query_page_data.page)
    this.fetchTaskUpdate(this.query_page.page)
    this.showProject(this.project_id)
    const queryParams = this.$route.query || {}
    this.query_page.page = queryParams.page || 1
    this.query_page.limit = queryParams.limit || 20
    this.fetchLiveTask(this.query_page.page)
    this.fetchTask(this.query_page.page)
    this.fetchProject()
    this.fetchLeadList()
  },
  methods: {
    ProjectUpdateCalendar (index) {
      this.all_task_details[index].configdateTimePicker.maxDate = this.all_task_details[index].due_date.split(' ')[0]
    }
  }
}
</script>

<style>
.userModalStyle
{
  z-index: 100000;
}
    
</style>